import { BYO_SET_USER_LOGIN, BYO_SET_WAITING_FOR_LOGIN } from '../constants';
const initialState = {
    isUserLoggedIn: false,
    isWaitingForLogin: false,
};
//eslint-disable-next-line complexity
const authReducer = (state = initialState, action = { type: '', payload: '' }) => {
    if (!action) {
        return state;
    }
    if (action.type === BYO_SET_USER_LOGIN) {
        return Object.assign(Object.assign({}, state), { isUserLoggedIn: action.payload });
    }
    if (action.type === BYO_SET_WAITING_FOR_LOGIN) {
        return Object.assign(Object.assign({}, state), { isWaitingForLogin: action.payload });
    }
    return state;
};
export default authReducer;
